import { Pagination } from '../store-interfaces';

export const makeActionKey = (entityName: string, actionName: string): string =>
  `${entityName}__${actionName}`;

export default class CrudActionContainer {
  entityName: string;
  createAction: string;
  createSuccessAction: string;
  createFailAction: string;

  retrieveAllAction: string;
  retrievedAllAction: string;
  retrieveAction: string;
  retrievedAction: string;
  retrievedBatchAction: string;
  polledAction: string;
  localBatchUpdateAction: string;
  updateAction: string;
  updateSuccessAction: string;
  updateLocalAction: string;
  batchUpdateAction: string;
  deleteAction: string;
  deleteLocalAction: string;
  busyAction: string;
  unbusyAction: string;
  cloneAction: string;

  constructor(entityName: string) {
    this.entityName = entityName;

    this.createAction = this.makeActionKey('ENTITY_CREATE_INITIATE');
    this.createSuccessAction = this.makeActionKey('ENTITY_CREATE_SUCCESS');
    this.createFailAction = this.makeActionKey('ENTITY_CREATE_FAIL');
    this.retrieveAllAction = this.makeActionKey('ENTITY_RETRIEVE_ALL');
    this.retrievedAllAction = this.makeActionKey('ENTITY_RETRIEVED_ALL');
    this.retrieveAction = this.makeActionKey('ENTITY_RETRIEVE');
    this.retrievedAction = this.makeActionKey('ENTITY_RETRIEVED');
    this.retrievedBatchAction = this.makeActionKey('ENTITY_RETRIEVED_BATCH');
    this.polledAction = this.makeActionKey('ENTITY_POLLED');
    this.localBatchUpdateAction = this.makeActionKey(
      'ENTITY_LOCAL_BATCH_UPDATE',
    );
    this.updateAction = this.makeActionKey('ENTITY_UPDATE');
    this.updateSuccessAction = this.makeActionKey('ENTITY_UPDATE_SUCCESS');
    this.updateLocalAction = this.makeActionKey('ENTITY_UPDATE_LOCAL');
    this.batchUpdateAction = this.makeActionKey('ENTITY_BATCH_UPDATE');
    this.deleteAction = this.makeActionKey('ENTITY_DELETE');
    this.deleteLocalAction = this.makeActionKey('DELETE_LOCAL');
    this.busyAction = this.makeActionKey('ENTITY_BUSY');
    this.unbusyAction = this.makeActionKey('ENTITY_UNBUSY');
    this.cloneAction = this.makeActionKey('ENTITY_CLONE');
  }

  makeActionKey(actionName: string) {
    return makeActionKey(this.entityName, actionName);
  }

  busy(activity = '') {
    return {
      type: this.busyAction,
      activity,
    };
  }

  unbusy() {
    return {
      type: this.unbusyAction,
    };
  }

  createActionCreator<T>(entity: T) {
    return {
      type: this.createAction,
      entity,
    };
  }

  createSuccess<T>(entity: T) {
    return {
      type: this.createSuccessAction,
      entity,
    };
  }

  createFail<T>(entity: T) {
    return {
      type: this.createFailAction,
      entity,
    };
  }

  retrieved<T>(entity: T) {
    return {
      type: this.retrievedAction,
      entity,
    };
  }

  retrievedBatch<T>(entities: T) {
    return {
      type: this.retrievedBatchAction,
      entities,
    };
  }

  polled<T>(entity: T) {
    return {
      type: this.polledAction,
      entity,
    };
  }

  localBatchUpdate<T>(entities: T) {
    return {
      type: this.localBatchUpdateAction,
      entities,
    };
  }

  retrievedAll<T>(entities: T) {
    return {
      type: this.retrievedAllAction,
      entities,
    };
  }

  retrievedAllPagination<T>(entities: T, pagination: Pagination) {
    return {
      type: this.retrievedAllAction,
      entities,
      pagination,
    };
  }

  updateSuccess<T>(entity: T) {
    return {
      type: this.updateSuccessAction,
      entity,
    };
  }

  updateLocal<T>(entity: T) {
    return {
      type: this.updateAction,
      entity,
    };
  }

  deleteLocal<T>(entity: T) {
    return {
      type: this.deleteLocalAction,
      entity,
    };
  }
}
